import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource } from '@angular/material';
import { APIUrl } from '../../app-service-routing';
import { AdminPanelService } from '../../services/admin-panel.service';
import { Validators, FormBuilder, FormGroup, FormControl, FormArray } from '@angular/forms';

@Component({
  selector: 'app-sub-product-functinalites',
  templateUrl: './sub-product-functinalites.component.html',
  styleUrls: ['./sub-product-functinalites.component.scss']
})

export class SubProductFunctinalitesComponent implements OnInit {
  productForm: FormGroup;
  editproductForm: FormGroup;
  add_product_list: boolean = true;
  list_product_list: boolean = false;
  edit_product_list: boolean = true;
  list_data_product: any;
  list_data_subproduct: any;
  list_data_category: any;
  myFormValueChanges$;
  displayedColumns: string[] = [
    'subProductName',
    'enable',
    'Action'];
  dataSource;
  selected_category;
  selected_product;
  selectedValue: any = {};
  // choices:any;

  constructor(private adminpanelservice: AdminPanelService, private formBuilder: FormBuilder) { }
  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngOnInit() {
    // this.choices = [{ id: 1, q_name: '', a_type: '', c_length: '', o_count: '', lengthss: false, count: false, optioncc: [], addbtn: 0 }];
    this.categorylisting();
    this.createform();
    this.editform();
  }

  createform() {
    this.productForm = this.formBuilder.group({
      subProducts: this.formBuilder.array([
        this.getUnit()
      ])
    });
    this.myFormValueChanges$ = this.productForm.controls['subProducts'].valueChanges;
  }

  editform() {
    this.editproductForm = new FormGroup({
      categoryID: new FormControl(),
    });
    this.editproductForm = this.formBuilder.group({
      productID: ['', Validators.required],
      subProductName: ['', Validators.required],
      isActive: [true],
      subProductID: ['']
    });
  }

  ngOnDestroy(): void {
    this.myFormValueChanges$.unsubscribe();
  }

  // * Save form data
  // */
  save(model: any, isValid: boolean, e: any) {
    e.preventDefault();
    this.adminpanelservice.updateResultSet(APIUrl.adddeletesubproduct, model).subscribe(response => {
      console.log(response);
      if (response['message']) {
        this.list_product();
        this.productlisting(this.selectedValue.product)
        this.createform();
      }
    }, error => {
    });
  }

  /**
   * Create form unit
   */
  private getUnit() {
    return this.formBuilder.group({
      categoryID: [''],
      productID: ['', Validators.required],
      subProductName: ['', Validators.required],
      isActive: [true, Validators.required],
    });
  }

  /**
   * Add new unit row into form
   */
  private addUnit() {
    const control = <FormArray>this.productForm.controls['subProducts'];
    control.push(this.getUnit());
  }

  /**
   * Remove unit row from form on click delete button
   */
  private removeUnit(i: number) {
    const control = <FormArray>this.productForm.controls['subProducts'];
    control.removeAt(i);
  }


  edit_subproduct(datra) {
    this.edit_product();
    debugger;
    this.editproductForm.patchValue({
      productID: datra.productID,
      subProductName: datra.subProductName,
      isActive: datra.isActive,
      subProductID: datra.subProductID,
    });
  }


  // * edit form data
  // */
  edit(model: any, isValid: boolean) {
    debugger;
    var data = model;
    this.adminpanelservice.updateResultSet(APIUrl.editsubproduct, model).subscribe(response => {
      console.log(response);
      if (response['message']) {
        this.list_product();
        // this.productlisting(data.productID);
        this.createform();
        this.editform();
        this.sub_productlisting(data.productID);
      }
    }, error => {
    });
  }


  sub_productlisting(value) {
    this.adminpanelservice.getReseultSetList(APIUrl.subproducturl + value).subscribe(response => {
      this.list_data_subproduct = response;
      this.dataSource = new MatTableDataSource<PeriodicElement>(this.list_data_subproduct);
      this.dataSource.paginator = this.paginator;
    }, error => {
    });
  }

  productlisting(value) {
    this.adminpanelservice.getReseultSetList(APIUrl.productUrl + value).subscribe(response => {
      this.list_data_product = response;
      this.selectedValue.product = this.list_data_product[0].productID;
      this.sub_productlisting(this.list_data_product[0].productID);
    }, error => {
    });
  }

  categorylisting() {
    this.adminpanelservice.getReseultSetList(APIUrl.categoryUrl).subscribe(response => {
      this.list_data_category = response
      this.selectedValue.category = this.list_data_category[0].categoryID;
      this.productlisting(this.list_data_category[0].categoryID);
    }, error => {
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  edit_product() {
    this.list_product_list = true;
    this.add_product_list = true;
    this.edit_product_list = false;
  }
  // Add_product
  add_product() {
    this.list_product_list = true;
    this.add_product_list = false;
    this.edit_product_list = true;
  }
  //List_product
  list_product() {
    this.add_product_list = true;
    this.list_product_list = false;
    this.edit_product_list = true;
  }
}

// Sample data
export interface PeriodicElement {
  subProductName: string;
  enable: string;
  Action: string;

}
